import React, { Component } from "react";
import styled from "styled-components";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { graphql, compose } from "react-apollo";
import moment from "moment";
import { Config } from "constant";
import { ShowNotice } from "Store";
import { queryGetMe, mutationUpdateAgentManagement } from "Apollo";
import { Scrollbars } from "react-custom-scrollbars";
import Button from "module-common/Button";
import Avatar from "module-common/Avatar";
import LabelList from "module-common/label-list/LabelList";
import Panel from "./Panel";
import FieldRow from "./FieldRow";
import Tooltip from "module-common/Tooltip";
import Icon from "module-common/Icon";

export default compose(
  graphql(queryGetMe, { name: "agent" }),
  graphql(mutationUpdateAgentManagement)
)(
  observer(
    class ModuleSupervisorSetting extends Component {
      states = observable({
        name: "",
        nickname: "",
        email: "",
        labels: [],
        displayPicture: null,
        loading: false
      });

      componentWillReceiveProps(nextProps) {
        const {
          agent: { me }
        } = nextProps;
        if (me) {
          this.states.name = me.agent.displayName;
          this.states.nickname = me.agent.shortName;
          this.states.email = me.agent.email;
          this.states.displayPicture = me.agent.displayPicture;

          // prepare labels
          const labels = [];
          for (const label of me.agent.labels) {
            labels.push({
              label: label.labelTemplate.displayName,
              color: "#" + label.labelTemplate.color,
              value: label.labelTemplate
            });
          }
          labels.sort((a, b) => {
            if (a.value.order !== b.value.order) {
              return a.value.order > b.value.order;
            } else {
              return moment(a.value.dateCreated).isAfter(b.value.dateCreated);
            }
          });
          this.states.labels = labels;
        }
      }

      render() {
        return (
          <Scrollbars>
            <Wrapper>
              <Panel title="PROFILE">
                <MasterColumn>
                  <LeftColumn>
                    <label htmlFor="file">
                      <AvatarWrapper>
                        <StyledAvatar image={this.states.displayPicture} />
                      </AvatarWrapper>
                    </label>
                    <HiddenFileInput id="file" onChange={this.onImageUpload} />
                    <Label>
                      Change Photo
                      <Tooltip text="Max size 3Mb">
                        <Icon name="information" width={10} height={10} />
                      </Tooltip>
                    </Label>
                  </LeftColumn>
                  <RightColumn>
                    <FieldRow
                      label="Name"
                      value={this.states.name}
                      onChange={text => {
                        this.states.name = text;
                      }}
                    />
                    <FieldRow
                      label="Nickname"
                      value={this.states.nickname}
                      onChange={text => {
                        this.states.nickname = text;
                      }}
                    />
                    <FieldRow
                      label="Email"
                      value={this.states.email}
                      onChange={text => {
                        this.states.email = text;
                      }}
                    />

                    {/* <InputRow
                type="password"
                label="Change Password"
                inputWidth={140}
                isPassword
                value={this.states.password}
                onChange={text => {
                  "this.states.password = text;"
                }}
              />
              <InputRow
                type="password"
                label="Confirm New Password"
                inputWidth={140}
                isPassword
                value={this.states.confirmPassword}
                onChange={text => {
                  "this.states.confirmPassword = text;"
                }}
              /> */}
                    <LabelList labels={this.states.labels.slice()} />
                    <StyledButton
                      onClick={this.onSaveAgentManagement}
                      loading={this.states.loading}
                    >
                      Save
                    </StyledButton>
                  </RightColumn>
                </MasterColumn>
              </Panel>
            </Wrapper>
          </Scrollbars>
        );
      }

      onSaveAgentManagement = async () => {
        const { name, nickname, displayPicture } = this.states;

        this.states.loading = true;
        try {
          await this.props.mutate({
            variables: {
              agentDisplayName: name,
              agentShortName: nickname,
              agentDisplayPicture: displayPicture
            },
            refetchQueries: ["getMe"]
          });
          ShowNotice("profile-update-success");
        } catch (error) {
          ShowNotice("profile-update-error");
        }
        this.states.loading = false;
      };

      onImageUpload = event => {
        const file = event.target.files[0];
        const formData = new FormData();
        formData.append("file", file);

        fetch(`${Config.apiUrl}/uploadProfileImage`, {
          method: "POST",
          headers: {
            Accept: "application/json"
          },
          body: formData
        })
          .then(response => response.text())
          .then(url => {
            this.states.displayPicture = url;
          });
      };
    }
  )
);

const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  padding: 20px;
`;
const MasterColumn = styled.div`
  display: flex;
  flex-direction: row;
  padding: 45px;
`;
const LeftColumn = styled.div`
  width: 200px;
  display: flex;
  flex-direction: column;
`;
const RightColumn = styled.div`
  width: 300px;
  display: flex;
  flex-direction: column;
`;
const Label = styled.div`
  width: 140px;
  text-align: center;
  color: ${props => props.theme.uiText};
`;
const AvatarWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.theme.moduleBackground};
  margin-bottom: 10px;
  width: 140px;
  height: 140px;
  border-radius: 70px;
`;
const StyledAvatar = styled(Avatar)`
  width: 120px;
  height: 120px;
  border-radius: 60px;
  cursor: pointer;
`;
const StyledButton = styled(Button).attrs({ rounded: true, width: 100 })`
  margin-top: 30px;
`;
const HiddenFileInput = styled.input.attrs({
  type: "file",
  accept: "image/*"
})`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
`;



// WEBPACK FOOTER //
// ./src/module-agent-management/ModuleAgentManagementWithQueryMutation.js